import { Component, OnInit } from "@angular/core";
import { MastertablesService } from "../mastertables.service";
import { ActivatedRoute, Router } from "@angular/router";
import { RoutingConstants } from "../../constants/routingConstants";
import { Mastertable } from "src/app/models/mastertable";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";

@Component({
  selector: "app-create-mastertables",
  templateUrl: "./create-mastertables.component.html",
  styleUrls: ["./create-mastertables.component.scss"],
})
export class CreateMastertablesComponent implements OnInit {
  mastertable: Mastertable;
  routing: any;

  constructor(
    private mastertablesService: MastertablesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService
  ) {
    this.mastertable = new Mastertable(
      "",
      this.activatedRoute.data["_value"]["type"]
    );
  }

  ngOnInit(): void {
    if (this.mastertable.type == "S") {
      this.routing = RoutingConstants.masterTableRoutingS;
    } else if (this.mastertable.type == "D") {
      this.routing = RoutingConstants.masterTableRoutingD;
    }
  }

  onSave() {
    this.mastertablesService.createMasterTable(this.mastertable).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(
          data["mensaje"],
          this.routing.list
        );
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  goList() {
    this.router.navigate([this.routing.list]);
  }
}
